

const Bodies
 = () => {
    return ( 
        <div className = "topParent">
        <div className="Parent min-h-screen justify-center">

            <div className="myImage">
        <img className="myImg" src="/image1.JPG" loading="lazy" alt="My Image" />
        </div>
            <div className="text">
             <p>Hello, I'm Yahaya Abdulrazaq, a Front-End Engineer and QA Automation Engineer. I build responsive, user friendly interface using javaScript, React, HTML, and CSS,  and ensure quality through API testing and automation with Postman. I hold a Bachelor's degree in Mathematics and currently pursuing an MSc in Computer Science. I'm passionate about creating seamless digital experiences that are both functional and reliable. </p>
            </div>
        
       
        </div>
        
       </div>
     );
}
 
export default Bodies
;